import { FeedbackInterface } from '../types/misc';

const FeedbackBox = ({ error, success }: FeedbackInterface) => {
	return (
		<>
			<div
				hidden={error ? false : true}
				className='my-4 py-2 px-4 bg-red-400 bg-opacity-75 rounded-lg font-medium text-center text-white flex-wrap'
			>
				{error}
			</div>
			<div
				hidden={success ? false : true}
				className='my-4 py-2 px-4 bg-mint-400 bg-opacity-75 rounded-lg font-medium text-center text-white flex-wrap'
			>
				{success}
			</div>
		</>
	);
};

export default FeedbackBox;
